module.exports = __webpack_public_path__ + "media/assets/services_manager/flags/hong_kong-f36a93069c35be7fd91d75f522d9dae3a33c2c7bb865bc15521d975ad4d2bc22.png";